import { apiClient } from "../lib/apiClient";
import type { EnrolmentRow, EventDashboardStats } from "../types";

export async function getEventDashboardStats(eventId: string): Promise<EventDashboardStats> {
  const { data } = await apiClient.get<{ stats: EventDashboardStats }>(`/events/${eventId}/dashboard`);
  return data.stats;
}

export interface EnrolmentFilters {
  search?: string;
  status?: string;
  whatsapp?: string;
}

export async function listEnrolments(eventId: string, filters: EnrolmentFilters): Promise<EnrolmentRow[]> {
  const params = new URLSearchParams();
  if (filters.search) params.set("search", filters.search);
  if (filters.status) params.set("status", filters.status);
  if (filters.whatsapp) params.set("whatsapp", filters.whatsapp);

  const { data } = await apiClient.get<{ enrolments: EnrolmentRow[] }>(`/events/${eventId}/enrolments?${params.toString()}`);
  return data.enrolments;
}

export function exportEnrolmentsUrl(eventId: string): string {
  return `/api/events/${eventId}/enrolments/export`;
}

export async function sendWhatsapp(eventId: string, enrolmentId: string): Promise<{ waLink: string; confirmationUrl: string }> {
  const { data } = await apiClient.post<{ waLink: string; confirmationUrl: string }>(
    `/events/${eventId}/whatsapp/${enrolmentId}`,
  );
  return data;
}

export interface WhatsappSendLogEntry {
  id: string;
  studentNames: string;
  sentBy: { id: string; name: string; email: string };
  createdAt: string;
}

export async function getWhatsappSendLog(eventId: string, parentId: string): Promise<WhatsappSendLogEntry[]> {
  const { data } = await apiClient.get<{ logs: WhatsappSendLogEntry[] }>(`/events/${eventId}/whatsapp-log/${parentId}`);
  return data.logs;
}

export async function updateParent(
  eventId: string,
  parentId: string,
  input: { name?: string; phone?: string },
): Promise<{ id: string; name: string; phone: string }> {
  const { data } = await apiClient.patch<{ parent: { id: string; name: string; phone: string } }>(
    `/events/${eventId}/parents/${parentId}`,
    input,
  );
  return data.parent;
}

export async function removeParentFromEvent(eventId: string, parentId: string): Promise<void> {
  await apiClient.delete(`/events/${eventId}/parents/${parentId}`);
}

export async function updateStudent(
  eventId: string,
  studentId: string,
  input: { name?: string; icNumber?: string; age?: number },
): Promise<{ id: string; name: string; icNumber: string; age: number }> {
  const { data } = await apiClient.patch<{ student: { id: string; name: string; icNumber: string; age: number } }>(
    `/events/${eventId}/students/${studentId}`,
    input,
  );
  return data.student;
}

export async function removeStudentFromEvent(eventId: string, studentId: string): Promise<void> {
  await apiClient.delete(`/events/${eventId}/students/${studentId}`);
}
